import React, { Component } from 'react';
import { connect } from "react-redux";

import moment from "moment";

import { GridContainer, GridItem } from '../../../../Common/DesignSystem/Grid';
import { Tabs, TabItem } from '../../../../Common/DesignSystem/Tabs';
import { LoadingIconRow } from '../../../../Common/Loading_Icon';
import { Trans } from 'react-i18next';
import { BookingRow } from '../../../../Common/DesignSystem/TableRows/ProfileBookingsRow';
import EmptyState from '../../../../Common/EmptyState';

class ProfileBookingsTab extends Component {
    constructor(props) {
        super(props);

        this.renderTable = this.renderTable.bind(this);
        this.gatherBookings = this.gatherBookings.bind(this);

        this.state = {
            loading: true,
            bookings: {
                bookingsAll: [],
                bookingsRequests: [],
                bookingsConfirmed: [],
                bookingsActive: [],
                bookingsCompleted: [],
                bookingsCancelled: [],
            },
            current_type: "All",
        };
    }

    componentDidMount() {
       this.gatherBookings(); 
    }

    async gatherBookings() {
        let total = [];
        let requests = [];
        let confirmed = [];
        let active = [];
        let completed = [];
        let cancelled = [];
        
        let promises = [];

        promises[0] = this.props.profile_details.bookings.current.map((booking)=> {
            let new_booking = booking;
            new_booking['tab'] = 'active';
            active.push(new_booking);
            total.push(new_booking);
        })
        promises[1] = this.props.profile_details.bookings.pending.map((booking)=> {
            let new_booking = booking;
            new_booking['tab'] = 'request';
            requests.push(new_booking);
            total.push(new_booking);
        })
        promises[2] = this.props.profile_details.bookings.upcomming.map((booking)=> {
            let new_booking = booking;
            new_booking['tab'] = 'confirmed';
            confirmed.push(new_booking);
            total.push(new_booking);
        })
        promises[3] = this.props.profile_details.bookings.past.map((booking)=> {
            let new_booking = booking;
            new_booking['tab'] = 'completed';
            completed.push(new_booking);
            total.push(new_booking);
        })
        promises[4] = this.props.profile_details.bookings.cancelled.map((booking)=> {
            let new_booking = booking;
            new_booking['tab'] = 'cancelled';
            cancelled.push(new_booking);
            total.push(new_booking);
        });

        await Promise.all(promises);
        this.setState({
            bookings: {
                bookingsAll: total,
                bookingsRequests: requests,
                bookingsConfirmed: confirmed,
                bookingsActive: active,
                bookingsCompleted: completed,
                bookingsCancelled: cancelled
            },
            loading: false
        });
    }

    renderTable() {
        if (this.state.bookings['bookings' + this.state.current_type].length > 0) {
            return(   
                this.state.bookings['bookings' + this.state.current_type].map((booking, index) => {
                    return ( <BookingRow booking={booking} alt={index % 2 !== 0} key={booking.BOOK_ID}/> )
                })       
            )
        } else {
            return (
                <tr>
                    <td colSpan = '9'><EmptyState image="bookings-emptystate.svg" text="No Bookings" /></td>
                </tr>
            )
        }
    }

    render(props) {
        return(
            <div className="row expanded bkg-white-dark">
                <div className="columns large-12 medium-12 small-12">
                    <GridContainer justifyContent='space-evenly' direction="column" spacing={0}>
                        <GridItem xs={12}>
                            <div className="ds-card">
                                <Tabs value={this.state.current_type} onChange={(e) => {this.setState({current_type: e.currentTarget.dataset.id})}}>
                                    <TabItem label="All"/>
                                    <TabItem label="Requests"/>
                                    <TabItem label="Active"/>
                                    <TabItem label="Confirmed"/>
                                    <TabItem label="Completed"/>
                                    <TabItem label="Cancelled"/>
                                </Tabs>
                                <table className = "ds-table" style={{marginTop: 16}}>
                                    <thead>
                                        <tr className = "table-header">
                                            <th style = {{width: "120px"}} className={"align-center"}>
                                                <Trans>Status</Trans>
                                            </th>
                                            <th className={"align-left"}>
                                                <Trans>Vehicle</Trans>
                                            </th>
                                            <th style={{width: '140px'}} className={"align-center"}>
                                                <Trans>Vehicle Tier</Trans>
                                            </th>
                                            <th style={{width: '280px'}} className={"align-center"}>
                                                <Trans>Booking Date</Trans>
                                            </th>
                                            <th style={{width: '120px'}} className={"align-center"}>
                                                <Trans>Type</Trans>
                                            </th>
                                            <th style={{width: '60px'}} className={"align-center"}>
                                                <Trans># Days</Trans>
                                            </th>
                                            <th style={{width: '60px'}} className={"align-center"}>
                                                <Trans>Damage</Trans>
                                            </th>
                                            <th style={{width: '60px'}} className="align-center">
                                                <Trans>Expenses</Trans>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.loading ?
                                                LoadingIconRow(8)
                                                : this.renderTable()
                                        }
                                    </tbody>
                                </table>
                                </div>
                        </GridItem>
                    </GridContainer>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(ProfileBookingsTab)